import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f35f536a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=f35f536a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f35f536a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f35f536a')) {
      api.createRecord('f35f536a', component.options)
    } else {
      api.reload('f35f536a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f35f536a&scoped=true&", function () {
      api.rerender('f35f536a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/list/index.vue"
export default component.exports